import { demoOrganization } from '../data/demo';
import type { Organization } from '../types';

export function BrandMark({
  compact = false,
  organization,
  productOnly = false,
}: {
  compact?: boolean;
  organization?: Organization;
  productOnly?: boolean;
}) {
  const currentOrganization = organization ?? demoOrganization;
  const accessibleName = productOnly ? 'Lazo' : currentOrganization.name;
  const displayName = productOnly ? 'Lazo' : currentOrganization.communityName;

  return (
    <div className="brand-mark" aria-label={accessibleName}>
      <span className="brand-mark__symbol" aria-hidden="true">
        <i />
        <i />
        <i />
      </span>
      {!compact && (
        <span className="brand-mark__copy">
          <strong>{displayName}</strong>
          <small>{productOnly ? 'Comunidad institucional' : 'por Lazo'}</small>
        </span>
      )}
    </div>
  );
}
